import { MODULE, VARICON_BASE_URL } from './globals';

/**
 * Varicon Academy
 */
export const VARICON_ACADEMY_URL = 'https://academy.varicon.com.au/';

/**
 * Arrows for onboarding
 */
export const ONBOARDING_URL = 'https://app.arrows.to/';

export const APP_LINKS = {
  PRIVACY_POLICY: `${VARICON_BASE_URL}/privacy-policy/`,
  LICENSE_AGREEMENT: `${VARICON_BASE_URL}/end-user-license-agreement/`,
  LANDING_PAGE: VARICON_BASE_URL,
};

/**
 * Jotform feedback form
 */
const FEEDBACK_FORM_BASE_URL = 'https://form.jotform.com';

export const FEEDBACK_FORM_URL = {
  BILLS: `${FEEDBACK_FORM_BASE_URL}/243168417438462`,
  PURCHASE_ORDER: `${FEEDBACK_FORM_BASE_URL}/240610895981464`,
  LEAVE_MANAGEMENT: `${FEEDBACK_FORM_BASE_URL}/251352721347049`,
  DASHBOARD: `${FEEDBACK_FORM_BASE_URL}/251399239944067`,
  SCHEDULER: `${FEEDBACK_FORM_BASE_URL}/251900244553047`,
};

/**
 * Freshdesk
 */
const FRESHDESK_BASE_URL =
  'https://varicon.freshdesk.com/support/solutions/articles';
/**
 * @deprecated Use pylon KNOWLEDGEBASE_URLS
 * */
export const FRESHDESK_URLS = {
  TIMESHEET: `${FRESHDESK_BASE_URL}/51000359178-03-timesheets-and-payroll-rollout`,
  BILLS: `${FRESHDESK_BASE_URL}/51000435837-varicon-bills-module`,
  ALLOWANCE:
    'https://varicon.freshdesk.com/support/solutions/articles/51000352131-allowances',
  EMPLOYEE:
    'https://varicon.freshdesk.com/support/solutions/articles/51000359178-03-timesheets-and-payroll-rollout#Setting-up-a-new-employee-and-downloading-the-app',
};

export const KNOWLEDGE_BASE_BASEURL = 'https://varicon.help.usepylon.com/';

/**
 * Varicon Knowledge BASE urls
 * Current: Pylon
 */
const KNOWLEDGE_BASE = 'https://varicon.help.usepylon.com/articles';

export const KNOWLEDGEBASE_URLS = {
  // bills
  [MODULE.BILLS]: `${KNOWLEDGE_BASE}/6922446007-varicon-bills-module`,
  [MODULE.BILLS_APPROVAL_WORKFLOW]: `${KNOWLEDGE_BASE}/3767547415-bills-approver-workflow-settings`,

  // leave
  [MODULE.LEAVE]: `${KNOWLEDGE_BASE}/6307843189-leave-management`,

  // pay rules
  [MODULE.PAY_RULES]: `${KNOWLEDGE_BASE}/8400942501-varicon-pay-rules`,

  // scheduler
  [MODULE.SCHEDULER]: `${KNOWLEDGE_BASE}/9640841697-varicon-scheduler-module`,

  // users
  [MODULE.USERS]: `${KNOWLEDGE_BASE}/2764875036-setting-up-users`,

  // daily cost tracking
  [MODULE.DAILY_COST_TRACKING]: `${KNOWLEDGE_BASE}/8110053926-01-how-cost-tracking-works-in-varicon`,

  // timesheet
  [MODULE.TIMESHEET]: `${KNOWLEDGE_BASE}/3255713384-timesheet-management`,

  // timesheet matrix
  [MODULE.TIMESHEET_MATRIX]: `${KNOWLEDGE_BASE}/3255713384-timesheet-management`,

  // docket
  [MODULE.DELIVERY_DOCKET]: `${KNOWLEDGE_BASE}/4647353627-capturing-and-editing-dockets-on-web-browser`,

  // purchase order
  [MODULE.PURCHASE_ORDER]: `${KNOWLEDGE_BASE}/4211303798-creating-a-purchase-order`,
  [MODULE.PURCHASE_ORDER_SETTINGS]: `${KNOWLEDGE_BASE}/4176465628-purchase-order-settings`,

  // site diary
  [MODULE.SITEDIARY]: `${KNOWLEDGE_BASE}/3424338618-site-diary`,

  // forecast
  [MODULE.FORECAST]: `${KNOWLEDGE_BASE}/7134317322-forecasting`,

  // fctc
  [MODULE.FCTC]: `${KNOWLEDGE_BASE}/1036029854-forecast-cost-to-complete`,

  // production tracking
  [MODULE.PRODUCTION_TRACKING]: `${KNOWLEDGE_BASE}/3678955774-production-tracking-on-varicon-web-app`,

  // claim
  [MODULE.CLAIM_SETTING]: `${KNOWLEDGE_BASE}/7118897402-setting-up-progress-claims`,
  [MODULE.CLAIM]: `${KNOWLEDGE_BASE}/9534194900-creating-your-first-progress-claim`,
  [MODULE.SETTING_UP_VARIATION_IN_CLAIM]: `${KNOWLEDGE_BASE}/7367705436-contract-management-claims-and-variations`,

  // project
  [MODULE.PROJECT]: `${KNOWLEDGE_BASE}/8392247710-setting-up-a-project-in-varicon`,

  // equipment
  [MODULE.EQUIPMENT]: `${KNOWLEDGE_BASE}/2524931169-setting-up-equipment`,

  // allowance
  [MODULE.ALLOWANCE]: `${KNOWLEDGE_BASE}/7083563198-setting-up-allowances-on-varicon`,

  // equipment type
  [MODULE.EQUIPMENT_TYPE]: `${KNOWLEDGE_BASE}/7871939149-equipment-types`,

  // timesheet settings
  [MODULE.TIMESHEET_SETTINGS]: `${KNOWLEDGE_BASE}/6414819048-timesheet-settings`,

  // roles and permissions
  [MODULE.ROLES_AND_PERMISSIONS]: `${KNOWLEDGE_BASE}/6152129452-permission-settings`,

  // accounting codes
  [MODULE.ACCOUNTING_CODES]: `${KNOWLEDGE_BASE}/7174245463-accounting-codes`,

  // resource assigner
  [MODULE.RESOURCE_ASSIGNER]: `${KNOWLEDGE_BASE}/2568571147-resource-assigner`,

  // accounting integration settings
  [MODULE.ACCOUNTING_INTEGRATION_SETTINGS]: `${KNOWLEDGE_BASE}/9126806635-setting-up-accounting-integration-xero-myob-account-right`,

  // custom forms
  [MODULE.CUSTOM_FORMS]: `${KNOWLEDGE_BASE}/4644049083-custom-forms`,

  // daywork docket
  [MODULE.DAYWORK_DOCKET]: `${KNOWLEDGE_BASE}/4370239549-managing-daywork-dockets-on-varicon`,

  [MODULE.VARIATION_REGISTER]: `${KNOWLEDGE_BASE}/4277065470-creating-a-variation-claim`,

  // dashboard
  [MODULE.DASHBOARD]: `${KNOWLEDGE_BASE}/1322472210-varicon-dashboard`,

  // employee
  [MODULE.EMPLOYEE]: `${KNOWLEDGE_BASE}/2609265420-03-timesheets-and-payroll-rollout`,

  [MODULE.REPORT]: `${KNOWLEDGE_BASE}/7487059969-dashboard-and-reports`,

  [MODULE.RESOURCE]: `${KNOWLEDGE_BASE}/7002095109-adding-resources-in-varicon`,

  [MODULE.ESTIMATION_SHEET]: `${KNOWLEDGE_BASE}/3532128782-estimating-with-varicon`,
  [MODULE.EXPERT_ESTIMATOR]:`${KNOWLEDGE_BASE}/2327520878-using-expert-estimator-file-to-upload-project-in-varicon`
};
